import { c as _c } from "react/compiler-runtime";
import { ThemeProvider as NextThemeProvider } from 'next-themes';

/**
 * Where the chosen theme is kept. Shared with the inline script in
 * `src/index.html`, which reads it before the first paint so a reader who
 * picked the dark workshop never gets a flash of paper white.
 */
export const THEME_STORAGE_KEY = 'ptl.theme';
export const ThemeProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <NextThemeProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true} storageKey={THEME_STORAGE_KEY}>{children}</NextThemeProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};